import {
    object,
    ObjectSchema,
} from "yup";
import * as yup from "yup";
import { RecuperarSenhaContract } from "../contracts/recuperar-senha.contract";

export const recuperarSenhaSchema: ObjectSchema<RecuperarSenhaContract> = object({
    password1: yup
        .string()
        .required("A senha é obrigatória")
        .min(8, "A senha deve ter no mínimo 8 caracteres")
        .matches(/[!@#$%^&*(),.?":{}|<>]/, "A senha deve conter ao menos um caractere especial"),

    password2: yup
        .string()
        .required("Confirmação de senha é obrigatória")
        .oneOf([yup.ref("password1")], "As senhas não coincidem"),
});

export type RecuperarSenhaFormData = yup.InferType<typeof recuperarSenhaSchema>;